module.exports = __webpack_public_path__ + "img/brl_fiatrail.34b6b92.png";